import React from 'react';

import classes from './Tooltip.scss';

const tooltip = (props) => {

    const { showTooltip, ...rest } = props;

    let tooltipClasses = [classes.Tooltip];

    if(props.type === 'validationFrom') {
        tooltipClasses.push(classes.ValidationFromTooltip);
    }
    if(props.type === 'validationTo') {
        tooltipClasses.push(classes.ValidationToTooltip);
    }
    if(props.type === 'stopCity') {
        tooltipClasses.push(classes.StopCityTooltip);
    }
    if(props.type === 'seatsLeft') {
        tooltipClasses.push(classes.SeatsLeftTooltip);
    }
    if(props.type === 'firstName') {
        tooltipClasses.push(classes.firstNameTooltip);
    }
    if(props.type === 'lastName') {
        tooltipClasses.push(classes.lastNameTooltip);
    }
    if(props.type === 'dob') {
        tooltipClasses.push(classes.dobTooltip);
    }
    if(props.type === 'departure') {
        tooltipClasses.push(classes.departureTooltip);
    }
    if(props.type === 'validationDestination') {
        tooltipClasses.push(classes.ValidationDestinationTooltip);
    }
    if(props.type === 'validationCardNumber') {
        tooltipClasses.push(classes.ValidationCardNumberTooltip);
    }
    if(props.type === 'validationCardName') {
        tooltipClasses.push(classes.ValidationCardNameTooltip);
    }
    if(props.type === 'validationCVV') {
        tooltipClasses.push(classes.ValidationCVVTooltip);
    }

    if(props.showTooltip && props.type === 'validationFrom') {
        tooltipClasses.push(classes.ShowValidationFromTooltip);
    }

    if(props.showTooltip && props.type === 'validationTo') {
        tooltipClasses.push(classes.ShowValidationToTooltip);        
    }

    if(props.showTooltip && props.type === 'firstName') {
        tooltipClasses.push(classes.ShowFirstNameTooltip);
    }

    if(props.showTooltip && props.type === 'lastName') {
        tooltipClasses.push(classes.ShowLastNameTooltip);
    }

    if(props.showTooltip && props.type === 'dob') {
        tooltipClasses.push(classes.ShowDobTooltip);
    }

    if(props.showTooltip && props.type === 'departure') {
        tooltipClasses.push(classes.ShowDepartureTooltip);
    }

    if(props.showTooltip && props.type === 'validationDestination') {
        tooltipClasses.push(classes.ShowDestinationTooltip);
    }

    if(props.showTooltip && props.type === 'validationCardNumber') {
        tooltipClasses.push(classes.ShowCardNumberTooltip)
    }
    
    if(props.showTooltip && props.type === 'validationCardName') {
        tooltipClasses.push(classes.ShowCardNameTooltip);
    }

    if(props.showTooltip && props.type === 'validationCVV') {
        tooltipClasses.push(classes.ShowCVVTooltip);
    }

    return (
        <span {...rest} className={tooltipClasses.join(' ')}>{props.children}</span>
    );
}

export default tooltip;


// WEBPACK FOOTER //
// ./src/components/UI/Tooltip/Tootip.js